import React, { useEffect, useState } from 'react';
import { useAuthentication } from '../../state/Authentication';
import Breadcrumbs from '../Breadcrumbs';
import { useHeaderLinks } from './hooks';
import './style.scss';
import useConfig from '../../hooks/config.hooks';

interface HeaderProps {
  hideBreadcrumbs?: boolean;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'mtn-header': any;
    }
  }
}

const Header: React.FC<HeaderProps> = ({ hideBreadcrumbs }) => {
  const {
    state: { user },
  } = useAuthentication();
  const links = useHeaderLinks(user);
  const { METANAV_SCRIPT_URL } = useConfig();
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (window && document && !scriptLoaded) {
      (window as any).mtnLogoutFunction = () => {
        window.location.href = '/auth/logout';
      };

      // Check if the script already exists in the DOM
      if (!document.querySelector(`script[src="${METANAV_SCRIPT_URL}"]`)) {
        const script = document.createElement('script');
        script.src = new URL(
          METANAV_SCRIPT_URL ||
            'https://acpaasui.s3.amazonaws.com/mtn/metanav.version_4.0.0-alpha0.min.js',
        ).href;

        script.addEventListener('load', () => {
          setScriptLoaded(true);
        });

        const body = document.getElementsByTagName('body')[0];
        body.appendChild(script);
      } else {
        // If the script already exists, consider it as loaded
        setScriptLoaded(true);
      }
    }
  }, [METANAV_SCRIPT_URL, scriptLoaded]);

  if (!scriptLoaded) return null;

  return (
    <mtn-header
      mtnid="prod-mtnapp-39f46fcf-8dbd-4256-a49b-7f81f9107491"
      config={JSON.stringify({
        profile: {
          links,
        },
      })}
      profileUser={JSON.stringify(user)}
      logoutFunction="mtnLogoutFunction"
      webcomponent="true"
    >
      {!hideBreadcrumbs && <Breadcrumbs />}
    </mtn-header>
  );
};

export default Header;
